export function LoadingState() {
  return (
    <div className="state-center">
      <div className="state-box">
        <div className="spinner" aria-hidden="true" />
        <p>Checking your access…</p>
      </div>
    </div>
  );
}

interface ErrorStateProps {
  reason: string | null;
}

export function ErrorState({ reason }: ErrorStateProps) {
  const isMissing = reason === 'missing_token';
  const isExpired = reason === 'expired' || reason === 'invalid_signature' || reason === 'jwt_expired';

  return (
    <div className="state-center">
      <div className="state-box">
        <h2>
          {isMissing
            ? 'We need your access link.'
            : isExpired
              ? 'That link has expired.'
              : "We can't verify your access."}
        </h2>
        <p>
          {isMissing ? (
            <>
              This portal is accessed through the link in your welcome email. If you've lost it, email{' '}
              <a href="mailto:support@aicores.ai" style={{ color: 'var(--accent)' }}>
                support@aicores.ai
              </a>{' '}
              and we'll re-send it.
            </>
          ) : (
            <>
              Email{' '}
              <a href="mailto:support@aicores.ai" style={{ color: 'var(--accent)' }}>
                support@aicores.ai
              </a>{' '}
              from the address you used to sign up and we'll sort it out straight away.
            </>
          )}
        </p>
      </div>
    </div>
  );
}
